import React from 'react'
// import './specials.scss'
import AutoMenu from '../../react/AutoMenu'
import {Link} from 'react-router-dom'
export default function () {
  return(
    <div className="catering-page">
      <div className="top-banner">
        <h1>Banquet Packages</h1>
      </div>

      <AutoMenu categorysToShow={['nkjMlIqYqanDXQqyZIQr']} />

      <div className="full-menu-link-wrapper">
        <Link to="/order" className="button">Go to Full Menu</Link>
      </div>
    </div>
  )
}
